import React from 'react';
import { FiInfo } from "react-icons/fi";
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip'


export default function Info(props) {
    const information = props.information ? props.information : {
        title: 'deserted hollow uninhabited unoccupied',
        descr: 'Hier könnte ihre Werbung stehen.'
    }

    const isEdge = () => {
        //source -> https://stackoverflow.com/questions/9847580/how-to-detect-safari-chrome-ie-firefox-and-opera-browser

        // Internet Explorer 6-11
        var isIE = /*@cc_on!@*/false || !!document.documentMode;
        // Edge 20+
        return !isIE && !!window.StyleMedia;
    }

    return (< Tooltip style={{ position: "absolute", marginLeft: props.marginLeft ? props.marginLeft : isEdge()?'222px':'230px', marginTop: props.marginTop ? props.marginTop : isEdge()?'3px':'-5px' }
    } placement="right"
        title={
            < React.Fragment >
                <Typography color="inherit">{information.title}</Typography>
                <Typography style={{ fontSize: '12px' }}>{information.descr}</Typography>
            </React.Fragment >
        }
    >
        <div><FiInfo size={16} /></div>
    </Tooltip >);
}